<template>
  <div :style="tooltipStyles">
    <v-card class="d-inline-block width-100 cursor-pointer" v-click-outside="clickOutside">
      <v-list dense>
        <v-list-item-group v-model="selected" color="primary">
          <v-list-item :value=condition>
            <v-list-item-content>
              <v-list-item-title>Users that...</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item value="and">
            <v-list-item-content>
              <v-list-item-title>ALL OF</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item value="or">
            <v-list-item-content>
              <v-list-item-title>ANY OF</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import CvcqlBuilderIds from "@/helpers/CvcqlBuilderIds";

export default {
  name: "QueryBuilderTooltip",
  data() {
    return {
      condition: CvcqlBuilderIds.condition,
      addButton: null,
      addOperatorFunction: null,
      selected: null,
      tooltipStyles: {
        display: 'none'
      },
    };
  },
  methods: {
    clickOutside(e) {
      if (e.path?.indexOf(this.addButton) === -1) this.hide();
    },
    hide() {
      this.addButton = null;
      this.addOperatorFunction = null;

      this.tooltipStyles = {
        display: 'none',
      };
    },
    show(addButton, addOperatorFunction) {

      if (addButton === this.addButton) {
        this.hide();
      } else {
        this.addButton = addButton;
        this.addOperatorFunction = addOperatorFunction;
        this.selected = null;

        const buttonRect = addButton.getBoundingClientRect()
        this.tooltipStyles = {
          position: 'fixed',
          display: 'inline-block',
          backgroundColor: '#00000000',
          left: buttonRect.x + 'px',
          top: (buttonRect.y + 36) + 'px',
          width: '240px',
          fontSize: '12px',
          textAlign: 'center',
          zIndex: 10,
        };
      }
    },
  },
  watch: {
    selected(newVal) {
      if (!newVal) return;
      if (newVal === CvcqlBuilderIds.condition) {
        this.addOperatorFunction({[newVal]: {}});
      } else {
        this.addOperatorFunction({[newVal]: []});
      }
      this.hide();
    }
  }
}
</script>

<style scoped>
</style>